import request from './request'

// 个人中心的
export function getUserInfo() {
  const url = '/user'
  return request.get(url)
}

// 获取用户钱包的余额
export function getUserWallet() {
  const url = '/user/wallet'
  return request.get(url)
}

// 获取我的钱包1.5改版
export function getUserWalletNew() {
  const url = '/user/getMyMoney'
  return request.get(url)
}

// 获取我的钱包收入记录1.5改版
export function getUserWalletInList(page, limit = 10) {
  const url = '/user/getMyTradeList'
  return request.get(url, {
    params: {
      page,
      limit
    }
  })
}

// 提现记录
export function getUserWithdraw(page) {
  const url = '/user/withdraw_record'
  return request.get(url, {
    params: {
      page: page
    }
  })
}

// 账户的一些交易记录
export function getUserAccountDetail(type) {
  // 类型:1:分润;2:打赏
  const url = '/user/account_detail'
  return request.get(url, {
    params: {
      type: type
    }
  })
}

// 用户的优惠券
export function getUserCoupon(type) {
  // 1:未使用;2:已使用;3:已过期
  const url = '/user/coupon_list'
  return request.get(url, {
    params: {
      type: type
    }
  })
}

// 已购买课程
export function getUserCourse(type, keyword) {
  // 1:全部;2:微课;3:体系课
  const url = '/user/course_list'
  let params = {
    type: type
  }
  if (typeof keyword !== 'undefined') {
    params.keyword = keyword
  }
  return request.get(url, {
    params: params
  })
}

// 我的证书
export function getUserCertList(type, keyword) {
  // 1:全部;2:微课;3:体系课
  const url = '/user/cert_list'
  let params = {
    type: type
  }
  if (typeof keyword !== 'undefined') {
    params.keyword = keyword
  }
  return request.get(url, {
    params: params
  })
}

// 领取证书
export function getUserCert(course) {
  const url = 'user/get_cert'
  return request.get(url, {
    params: {
      course_id: course
    }
  })
}

// 申请提现
export function submitWithdraw(amount, accountAmount) {
  const url = '/withdraw/addWithdraw'
  return request({
    url,
    method: 'post',
    data: {
      amount,
      account_amount: accountAmount
    }
  })
}

// 绑定golo账号
export function bindGoloUser(username, pwd) {
  const url = '/user/bind_golo_user'
  return request({
    url,
    method: 'post',
    data: {
      user_name: username,
      password: pwd
    }
  })
}

// 获取我关注的大咖列表
export function getMyFollow() {
  const url = '/user/follow_list'
  return request.get(url)
}

// 领取证书
export function getCouponByCode(code) {
  const url = 'user/bind_coupon_by_code'
  return request.get(url, {
    params: {
      coupon_code: code
    }
  })
}

// 是否开通积分
export function isOpenIntegral() {
  const url = '/user/integral'
  return request.get(url)
}

// 是否绑定手机号
export function isBind() {
  const url = '/user/bindMobile'
  return request.get(url)
}

// 发送验证码
export function sendCode(mobile) {
  const url = '/sms/send'
  return request.get(url, {
    params: {
      mobile
    }
  })
}

// 绑定手机号
export function bindPhone(mobile, captcha) {
  const url = '/user/bindMobile'
  return request.get(url, {
    params: {
      mobile,
      captcha
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/user-center.js